import React from "react";
import "./Purpose.css";
import bg from "./header_orange_new_on_v2.webp";
import image1 from "./tw-icons-artboard-58.svg";
import image2 from "./tw-icons-artboard-33.svg";
const Purpose = () => {
  return (
    <>
      <div className="purpose-section ">
        <main
          id="main"
          className="reskin generic-content-page overflow-x-hidden"
        >
          <section
            className="jumbotron jumbotron-2 bg-size-cover d-flex position-relative w-100 p-0 mb-0"
            style={{
              backgroundImage: `url(${bg})`,
            }}
          >
            <div className="jumbotron-hero-header container">
              <h1
                className="m-0 font-slatepro-medium page-title display-size-1 color-white z-index-1 js-sr-intro-2 purpose-header-title"
                data-sr-id="1"
              >
                Our Purpose
              </h1>
              <ol className="breadcrumb p-0 py-2 m-0 color-white">
                <li className="breadcrumb-item color-white z-index-1">
                  <a href="/" className="color-white no-underline">
                    Home Page
                  </a>
                </li>
                <li className="breadcrumb-item color-white z-index-1">
                  <a href="/" className="color-white no-underline">
                    Who We Are
                  </a>
                </li>
                <li className="breadcrumb-item color-white z-index-1">
                  <a
                    href="/who-we-are/our-purpose/"
                    className="color-white no-underline"
                  >
                    Our Purpose
                  </a>
                </li>
              </ol>
            </div>
          </section>

          <div>
            <div>
              <section className="generic-content-block">
                <div className="container">
                  <div className="row">
                    <div className="col-12 ">
                      <h3 style={{ fontSize: "32px", textAlign: "left" }}>
                        For over twenty-five years, we have translated our
                        belief in the power of connecting people and technology
                        into better ways to trade. And the markets have changed,
                        for good.
                      </h3>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div>
              <div className="product-carousel">
                <div className="container">
                  <header className="title">
                    Purpose-Driven to Serve Global Markets
                  </header>
                  <div className="row slick-product-slider slick-initialized slick-slider">
                    <div className="slick-list draggable">
                      <div
                        className="slick-track"
                        style={{
                          opacity: "1",
                          width: " 100%",
                          transform: "translate3d(0px, 0px, 0px)",
                        }}
                      >
                        <div
                          className="slick-slide slick-current slick-active"
                          data-slick-index="0"
                          aria-hidden="false"
                          style={{ width: "100%" }}
                        >
                          <div>
                            <div
                              className="carousel-item"
                              style={{ width: "100%", display: "inline-block" }}
                            >
                              <div className="carousel-item-header">
                                <div className="image-container">
                                  <img
                                    src={image1}
                                    alt="Make Trading Better"
                                    className=""
                                  />
                                </div>
                              </div>
                              <div className="carousel-item-info">
                                <div className="flex flex-column">
                                  <h3 className="item-title">
                                    Make Trading Better
                                  </h3>
                                  <p className="item-description">
                                    Our purpose is simple. Making trading better
                                    defines us and our business culture, and it
                                    has led to remarkable changes.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="slick-slide slick-active"
                          data-slick-index="1"
                          aria-hidden="false"
                          style={{ width: "100%" }}
                        >
                          <div>
                            <div
                              className="carousel-item"
                              style={{ width: "100%", display: "inline-block" }}
                            >
                              <div className="carousel-item-header">
                                <div className="image-container">
                                  <img
                                    src={image2}
                                    alt="Move 1st, Never Stop"
                                    className=""
                                  />
                                </div>
                              </div>
                              <div className="carousel-item-info">
                                <div className="flex flex-column">
                                  <h3 className="item-title">
                                    Move 1st, Never Stop
                                  </h3>
                                  <p className="item-description">
                                    Our first revolution was to electronify
                                    fixed income trading - and we did just that.
                                    What once seemed radical has now become
                                    essential. But we won't stop there.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <section className="values-listing-block container">
                <header className="header-wrapper">
                  <h2 className="values-title">Our Values</h2>
                </header>
                <div className="values-list-wrapper row">
                  <div className="col-md-4 col-12">
                    <div className="values-card">
                      <div className="pill from-teal to-lime"></div>
                      <header>
                        <h3 className="card-title">Share Ideas</h3>
                      </header>

                      <p className="card-description">
                        Collaboration leads to innovation. Teamwork multiplies
                        our individual talents and makes our best ideas even
                        more powerful and useful.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <div className="values-card">
                      <div className="pill from-blue to-teal"></div>
                      <header>
                        <h3 className="card-title">Stay Curious</h3>
                      </header>

                      <p className="card-description">
                        Constantly questioning the status quo - our curiosity
                        and imagination keep us relevant, vital and valuable to
                        our clients and to one another.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <div className="values-card">
                      <div className="pill from-purple to-violet"></div>
                      <header>
                        <h3 className="card-title">Take Ownership</h3>
                      </header>

                      <p className="card-description">
                        We try new things, learn from our mistakes and refine
                        our ideas, knowing that accountability is part of how we
                        learn and get better at what we do.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <div className="values-card">
                      <div className="pill from-orange to-yellow"></div>
                      <header>
                        <h3 className="card-title">Exceed Expectations</h3>
                      </header>

                      <p className="card-description">
                        Our clients deserve the very best in every service and
                        solution we provide. We challenge ourselves and our
                        colleagues to deliver excellence in everything we do.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <div className="values-card">
                      <div className="pill from-light-cyan to-sky-purple"></div>
                      <header>
                        <h3 className="card-title">Act Responsibly</h3>
                      </header>

                      <p className="card-description">
                        We do our part to help financial markets move toward
                        more sustainable global systems, and take action to
                        improve the communities around the world where we live
                        and work.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <div className="values-card">
                      <div className="pill from-orange to-pink"></div>
                      <header>
                        <h3 className="card-title">Embrace Differences</h3>
                      </header>

                      <p className="card-description">
                        Our diverse experiences, backgrounds and views inform
                        and encourage new ways of thinking. We ensure an
                        inclusive and respectful workplace where all voices are
                        not only heard, but encouraged.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div></div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Purpose;
